import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { ContactCustomFieldType } from '../../types';
import * as Icons from '../../assets/icons';
import * as css from './AddCustomFieldModal.scss';
import { MessageBoxFunctionalLayout, FormField, Dropdown, Text, Input, listItemActionBuilder, Modal, } from 'wix-style-react';
export var FIELD_MAX_LENGTH = 30;
var AddCustomFieldModal = /** @class */ (function (_super) {
    __extends(AddCustomFieldModal, _super);
    function AddCustomFieldModal(props) {
        var _this = _super.call(this, props) || this;
        _this.typeOptions = function () { return [
            listItemActionBuilder({
                id: ContactCustomFieldType.Text,
                prefixIcon: React.createElement(Icons.text, null),
                title: _this.props.t('customFieldType.text'),
                skin: 'dark',
            }),
            listItemActionBuilder({
                id: ContactCustomFieldType.Number,
                prefixIcon: React.createElement(Icons.number, null),
                title: _this.props.t('customFieldType.number'),
                skin: 'dark',
            }),
            listItemActionBuilder({
                id: ContactCustomFieldType.Date,
                prefixIcon: React.createElement(Icons.date, null),
                title: _this.props.t('customFieldType.date'),
                skin: 'dark',
            }),
            listItemActionBuilder({
                id: ContactCustomFieldType.URL,
                prefixIcon: React.createElement(Icons.url, null),
                title: _this.props.t('customFieldType.url'),
                skin: 'dark',
            }),
        ]; };
        _this.onSelectType = function (customFieldType) {
            _this.setState({ customFieldType: customFieldType });
        };
        _this.onChange = function (customFieldName) {
            _this.setState({ customFieldName: customFieldName });
        };
        _this.isNameUnique = function () {
            var customFieldName = _this.state.customFieldName;
            var customField = _this.props.customField;
            var trimmedName = customFieldName && customFieldName.trim();
            if (customField &&
                customField.name &&
                customField.name.trim() === trimmedName) {
                return true;
            }
            return _this.props.validateUniqueCustomField(trimmedName);
        };
        _this.getInputStatus = function () { return (_this.isNameUnique() ? null : Input.StatusError); };
        _this.handleOnAdd = function () {
            var customFieldName = _this.state.customFieldName;
            _this.props.onAdd({
                type: _this.state.customFieldType,
                name: customFieldName && customFieldName.trim(),
                id: null,
            });
        };
        _this.handleOnRename = function () {
            var customFieldName = _this.state.customFieldName;
            _this.props.onRename(_this.props.customField, customFieldName && customFieldName.trim());
        };
        _this.renderNameField = function () { return (React.createElement(FormField, { dataHook: "custom-field-name-form-field", infoContent: _this.props.t('customFieldNameTooltip'), infoTooltipProps: AddCustomFieldModal.infoTooltipProps, label: _this.props.t('customFieldNameLabel') },
            React.createElement(Input, { dataHook: "custom-field-name-input", placeholder: _this.props.t('customFieldNamePlaceholder'), value: _this.state.customFieldName, onChange: function (_a) {
                    var value = _a.target.value;
                    return _this.onChange(value);
                }, maxLength: FIELD_MAX_LENGTH, status: _this.getInputStatus(), statusMessage: _this.props.t('customFieldExistingNameError') }))); };
        _this.renderTypeField = function (renameMode) { return (React.createElement(FormField, { infoContent: _this.props.t('customFieldTypeTooltip'), infoTooltipProps: AddCustomFieldModal.infoTooltipProps, dataHook: "custom-field-type-form-field", label: _this.props.t('customFieldTypeLabel') },
            React.createElement(Dropdown, { dataHook: "custom-field-type-dropdown", placeholder: _this.props.t('customFieldTypeDropdownPlaceholder'), options: _this.typeOptions(), selectedId: _this.state.customFieldType, onSelect: function (_a) {
                    var id = _a.id;
                    return _this.onSelectType(id);
                }, valueParser: function (option) { return _this.props.t("customFieldType." + option.id); }, disabled: !!renameMode }))); };
        _this.state = {
            customFieldType: (props.customField && props.customField.type) || null,
            customFieldName: (props.customField && props.customField.name) || null,
        };
        return _this;
    }
    AddCustomFieldModal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen && this.props.isOpen) {
            this.setState({
                customFieldType: (this.props.customField && this.props.customField.type) || null,
                customFieldName: (this.props.customField && this.props.customField.name) || null,
            });
        }
    };
    AddCustomFieldModal.prototype.render = function () {
        var _a = this.props, t = _a.t, onClose = _a.onClose, isOpen = _a.isOpen;
        var renameMode = (this.props.customField && this.props.customField.id) || null;
        var isConfirmationDisabled = !this.state.customFieldName ||
            !this.state.customFieldType ||
            !this.isNameUnique();
        return (React.createElement(Modal, { isOpen: isOpen, onRequestClose: onClose },
            React.createElement(MessageBoxFunctionalLayout, { dataHook: "add-custom-field-box", title: renameMode
                    ? t('renameCustomFieldDialogTitle')
                    : t('addCustomFieldDialogTitle'), confirmText: renameMode
                    ? t('renameCustomFieldDialogSave')
                    : t('addCustomFieldDialogAdd'), cancelText: t('addCustomFieldDialogCancel'), width: "504px", buttonsHeight: "medium", disableConfirmation: isConfirmationDisabled, onOk: renameMode ? this.handleOnRename : this.handleOnAdd, onCancel: onClose },
                React.createElement(Text, { dataHook: "edit-custom-field-dialog-body" }, t('addCustomFieldDialogBody')),
                React.createElement("div", { className: css.customFieldInputsContainer },
                    this.renderTypeField(renameMode),
                    this.renderNameField()))));
    };
    AddCustomFieldModal.infoTooltipProps = {
        theme: 'light',
        maxWidth: 200,
        appendToParent: false,
    };
    return AddCustomFieldModal;
}(React.Component));
export default translate()(AddCustomFieldModal);
//# sourceMappingURL=AddCustomFieldModal.js.map